export default "__VITE_ASSET__Chs5kgVV__"